import VOUCHER from '@/api/voucher'

const state = {
  list: []
}

const getters = {
  list: state => {
    return state.list
  }
}

const actions = {
  fetchVoucherList: function ({ commit, state }, params) {
    return VOUCHER.getVoucherList(params).then(res => {
      if (res.status === 200 && res.data) {
        commit('SET_VOUCHERLIST', res.data)
        return res.data
      } else {
        return res
      }
    })
  },
  fetchVoucherDetail: function ({ commit, state }, uuid) {
    return VOUCHER.getVoucherDetail(uuid).then(res => {
      if (res) {
        return res
      }
    })
  }
}

const mutations = {
  SET_VOUCHERLIST: function (state, payload) {
    state.list = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
